import React, {
    useCallback,
    useEffect,
} from 'react'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import { Typography } from '@mui/material'

import { useTranslation } from 'shared/hooks/useSafeTranslation'
import Loading from 'shared/Loading'
import PreLoadScannerProvider from 'shared/QRScanner/PreLoadScanner'
import ROUTE_KEYS from 'shared/utils/routeKeys'
import useStyle from 'shared/hooks/useStyle'

import useLocation from '../hook/useLocation'
import useLocationContext from '../LocationProvider/useLocationContext'

import styles from './CentersDashboard.style'

const propTypes = { children: PropTypes.element.isRequired }

function CentersDashboard({ children }) {
    const { t } = useTranslation()
    const classes = useStyle(styles)
    const navigate = useNavigate()
    const {
        location,
        setLocation,
    } = useLocationContext()
    const {
        data: centers,
        isLoading,
        error,
    } = useLocation(Boolean(!location.locationId))

    const onCenterSelect = useCallback((center) => {
        const contextValue = {
            locationName: center.name,
            locationId: center.id,
        }

        setLocation(contextValue)
        navigate(ROUTE_KEYS.MAIN)
    }, [
        setLocation,
        navigate,
    ])

    useEffect(() => {
        if (!location.locationId) {
            navigate(ROUTE_KEYS.MAIN)
        }
    }, [
        navigate,
        location.locationId,
    ])

    if (isLoading) {
        return (<Loading />)
    }
    if (error) {
        throw error
    }

    if (location.locationId) {
        return (
            <PreLoadScannerProvider>
                {children}
            </PreLoadScannerProvider>
        )
    }

    return (
        <div css={classes.root}>
            <div css={classes.main}>
                <div css={classes.userLocationTitle}>
                    <Typography
                        variant="h1"
                        css={classes.userLocationText}
                    >
                        {t('SELECT_SERVICE_CENTER')}
                    </Typography>
                </div>
                <div css={classes.container}>
                    {
                        centers.map((center) => {
                            return (
                                <div
                                    key={center.id}
                                    data-testid="service-center-item"
                                    css={classes.center}
                                    onClick={() => { onCenterSelect(center) }}
                                    aria-hidden="true"
                                >
                                    <Typography
                                        variant="h3"
                                        css={classes.centerText}
                                    >
                                        {center.name}
                                    </Typography>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
}

CentersDashboard.propTypes = propTypes

export default CentersDashboard
